export default str => {
    // Remove todos os espaços em branco e caracteres não alfanuméricos
    const cleanedStr = (str || '').replace(/[^\w\s]/gi, '');

    // Verifica se a entrada é um CPF
    if (/^\d{11}$/.test(cleanedStr)) {
        return cleanedStr.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, '$1.$2.$3-$4');
    }
    // Verifica se a entrada é um CNPJ
    else if (/^\d{14}$/.test(cleanedStr)) {
        return cleanedStr.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5');
    }
    // Verifica se a entrada é um email
    else if (/^.+@.+\..+$/.test(cleanedStr)) {
        return cleanedStr.toLowerCase();
    }
    
    // Caso não seja nenhum dos formatos suportados, retorne a entrada original
    return str;
};
